import { render } from "./TopNeedsTemplate.vue?vue&type=template&id=794728bb"
import script from "./TopNeedsTemplate.vue?vue&type=script&lang=js"
export * from "./TopNeedsTemplate.vue?vue&type=script&lang=js"
script.render = render

export default script